export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/scarf-c60cb56c8fb1b39fecc0a4014d660a8c.png";